/* eslint-disable no-console */
import * as Sentry from '@sentry/react';
import React from 'react';
import { useRouteError } from 'react-router';

import { IS_PRODUCTION } from 'constants/Global';

import ErrorRefreshPage from './ErrorRefreshPage';

/**
 * Route-level counterpart of {@link ErrorHandler}.
 *
 * Since the data-router migration, a failing `route.lazy` (the classic stale-deploy chunk 404) is
 * caught by the router instead of thrown inside the React tree, so `ErrorHandler` — a React error
 * boundary — never sees it. Without this component react-router falls back to its own boundary, which
 * replaces the *whole* matched chain (root `Component` included) with a bare
 * "Unexpected Application Error!" page, and the exception never reaches Sentry.
 *
 * Mounted on the route just below `App` so the surrounding providers (`IntlProvider`, antd's
 * `ConfigProvider`) stay alive — `ErrorRefreshPage` renders `FormattedMessage` and antd components and
 * would itself crash without them.
 */
const RouteErrorBoundary: React.FC = () => {
  const error = useRouteError();

  React.useEffect(() => {
    if (!IS_PRODUCTION) {
      console.error(error);
    }

    Sentry.captureException(error);
  }, [error]);

  return <ErrorRefreshPage />;
};

export default RouteErrorBoundary;
